import './Architecture.css';

export default function Architecture({ steps }) {
  return (
    <div className="architecture-shell" aria-label="Cloud architecture flow">
      <div className="architecture-line"></div>
      <div className="architecture-grid">
        {steps.map((step, index) => (
          <div key={step} className={`architecture-node architecture-node--step-${index + 1}`}>
            <span className="architecture-badge">{index + 1}</span>
            <h4>{step}</h4>
          </div>
        ))}
      </div>
    </div>
  );
}
